import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppColorStore {
  /** User's chosen primary color. null = use org/system default. */
  primaryColor: string | null
  setPrimaryColor: (color: string | null) => void
}

export const useAppColorStore = create<AppColorStore>()(
  persist(
    (set) => ({
      primaryColor: null,
      setPrimaryColor: (color) => set({ primaryColor: color }),
    }),
    { name: 'cmms-app-color' },
  ),
)
